import {createSlice} from '@reduxjs/toolkit'
import { removeReference } from '../../../utils/Reusables'

const initialState = {
    chartType: 'table',
    fields:[]
}

const reportSlice = createSlice({
    name:'reportDetails',
    initialState,
    reducers: {
        init(state,action){
            let newObj = action.payload
            let obj = removeReference(state)
            return {
                ...obj,
                ...newObj.reportDetails
            }
        },
        reset(){
            return {...initialState}
        },
        updateChartType(state,action){
            let newObj = action.payload
            let obj = removeReference(state)
            //console.log(obj,state,action)
            return {
                ...obj,
                chartType: newObj.chartType
            }
        },
        addField(state,action){
            let newObj = removeReference(action.payload)
            let obj = removeReference(state)
            obj.fields.push(newObj.field)
            //console.log(obj)
            return {
                ...obj,
                fields: obj.fields
            }
        },
        removeField(state,action){
            let fieldObj = action.payload
            let obj = removeReference(state)
            return {
                ...obj,
                fields: obj.fields.filter(elem => elem.member != fieldObj.fieldName)
            }
        },
        removeFieldByIndex(state,action){
            let fieldIndex = action.payload.fieldIndex
            let stateObj = removeReference(state)
            stateObj.fields.splice(fieldIndex, 1)
            return {
                ...stateObj
            }
        },
        updateFieldList(state,action){
            let fields = removeReference(action.payload)
            let stateObj = removeReference(state)
            console.log(fields,stateObj)
            return {
                ...stateObj,
                fields: fields.list
            }
        },
        updateFieldProperties(state,action){
            let updateObj = removeReference(action.payload)
            let stateObj = removeReference(state)
            switch(updateObj.type){
                case 'title':
                    stateObj.fields[updateObj.fieldIndex].displayName = updateObj.value
                    return {
                        ...stateObj
                    }
                case 'align':
                    stateObj.fields[updateObj.fieldIndex].align = updateObj.value
                    return {...stateObj}
                case 'format':
                    stateObj.fields[updateObj.fieldIndex].format = updateObj.value
                    return {...stateObj}
                case 'hide':
                    stateObj.fields[updateObj.fieldIndex].hidden = !stateObj.fields[updateObj.fieldIndex].hidden
                    return {...stateObj}
                case 'truncate':
                    stateObj.fields[updateObj.fieldIndex].truncate = !stateObj.fields[updateObj.fieldIndex].truncate
                    return {...stateObj}
                case 'truncateWith':
                    stateObj.fields[updateObj.fieldIndex].truncateWith = updateObj.value
                    return {...stateObj}
                case 'truncateCount':
                    stateObj.fields[updateObj.fieldIndex].truncateCount = updateObj.value
                    return {...stateObj}
                case 'delimiter':
                    stateObj.fields[updateObj.fieldIndex].delimiter = updateObj.value
                    return {...stateObj}
                case 'concatFlag':
                    stateObj.fields[updateObj.fieldIndex].concatFlag = !stateObj.fields[updateObj.fieldIndex].concatFlag
                    if(!stateObj.fields[updateObj.fieldIndex].concatFlag){                    
                        stateObj.fields[updateObj.fieldIndex].concatWith = []
                        let concatWithArr = stateObj.fields.map(obj => obj.concatWith)
                        let allConcated = concatWithArr.concat(...concatWithArr)
                        stateObj.fields = stateObj.fields.map(obj => {
                            if(allConcated.indexOf(obj.member) > -1){
                                obj.concated = true
                            }else{
                                obj.concated = false
                            }
                            return obj
                        })
                    }
                    return {...stateObj}
                case 'concatWith':
                    stateObj.fields[updateObj.fieldIndex].concatWith = [...updateObj.value]
                    let concatWithArr = stateObj.fields.map(obj => obj.concatWith)
                    let allConcated = concatWithArr.concat(...concatWithArr)
                    stateObj.fields = stateObj.fields.map(obj => {
                        if(allConcated.indexOf(obj.member) > -1){
                            obj.concated = true
                        }else{
                            obj.concated = false
                        }
                        return obj
                    })
                    /* let notconcatedArr = stateObj.fields.filter(obj => !obj.concated)
                        let concatedArr = stateObj.fields.filter(obj => obj.concated)
                        stateObj.fields = [...notconcatedArr,...concatedArr] */
                    return {...stateObj}
                default:
                    return {...stateObj}
            }
        },
        updateFilterList(state,action){
            let filters = removeReference(action.payload)
            let stateObj = removeReference(state)
            //console.log(fields,stateObj)
            return {
                ...stateObj,
                filters: filters.list
            }
        },
        addFilter(state,action){
            let newObj = removeReference(action.payload)
            let obj = removeReference(state)
            if(obj.filters){
                obj.filters.push(newObj.filter)
            }else{
                obj.filters = [newObj.filter]
            }            
            //console.log(obj)
            return {
                ...obj,
                filters: obj.filters
            }
        },
        updateFilterByIndex(state,action){
            let newObj = removeReference(action.payload)
            let obj = removeReference(state)
            //console.log(newObj,obj)
            obj.filters.splice(newObj.index, 1, newObj.filter);
            //console.log(newObj,obj)
            return {
                ...obj,
                filters: obj.filters
            }
        },
        deleteFilterByIndex(state,action){
            let newObj = removeReference(action.payload)
            let details = removeReference(state)
            let toBeDeletedFilter = details.filters[newObj.index]
            details.filters.splice(newObj.index, 1);
            details.filters = details.filters.map(obj => {
                if(obj.cascadedWith === toBeDeletedFilter.member){
                    obj.cascadedWith = ''
                    obj.cascaded = false
                }
                return obj
            })
            return {
                ...details,
                filters: details.filters
            }
        },
        updateExtraFilterByIndex(state,action){
            let newObj = removeReference(action.payload)
            let details = removeReference(state)
            //console.log(newObj)
            details.filters[newObj.filterIndex].extraFilters.splice(newObj.extraFilterIndex, 1, newObj.filterObj);
            return {
                ...details,
                filters: details.filters
            }
        },
        deleteExtraFilterByIndex(state,action){
            let newObj = removeReference(action.payload)
            let details = removeReference(state)
            details.filters[newObj.filterIndex].extraFilters.splice(newObj.extraFilterIndex, 1);
            return {
                ...details,
                filters: details.filters
            }
        }

    }
})

export const reportActions = reportSlice.actions

export default reportSlice.reducer